import { render, staticRenderFns } from "./RouterInfoPage.vue?vue&type=template&id=b492fc4e&"
import script from "./RouterInfoPage.vue?vue&type=script&lang=ts&"
export * from "./RouterInfoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports